// extracted by mini-css-extract-plugin
export default {"domain":"domain-b9657e2f"};